import { properties } from "@repoflow/common/schema-fields";

const { createdAt,
  updatedAt } = properties

export {
  createdAt,
  updatedAt
}

export const orgId = {
  type: "string"
};
export const bucketId = {
  label: "BucketId",
  type: "string"
};

export const description = {
  label: "Description",
  type: "string"
};

export const exts = {
  label: "Allow extensions",
  type: "array",
  items: {
    type: "string",
    default: "",
  },
  default: [],
  widget: "tags",
};

export const minFileSize = {
  label: "Minimun file size (bytes)",
  type: "integer",
};
export const maxFileSize = {
  label: "Maximun file size (bytes)",
  type: "integer",
};

export const size = { type: "integer", label: "Size (bytes)" };

export const status = {
  type: "string",
};
